import { render, staticRenderFns } from "./ModalDeleteProject.vue?vue&type=template&id=655a5216&scoped=true&"
import script from "./ModalDeleteProject.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655a5216",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655a5216')) {
      api.createRecord('655a5216', component.options)
    } else {
      api.reload('655a5216', component.options)
    }
    module.hot.accept("./ModalDeleteProject.vue?vue&type=template&id=655a5216&scoped=true&", function () {
      api.rerender('655a5216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/ModalDeleteProject.vue"
export default component.exports